<app-loader *ngIf="status === 'loading'"></app-loader>
<section>
    <div *ngIf="status === 'error'" class="status-error">
        <div class="icon-container">
            <div><img src="assets/images/error-icon.svg" alt="Error Icon"></div>
        </div>
        <div class="message-container">
            <div class="status-title">Something Went Wrong</div>
            <div class="notification-message">We couldn’t process your request. Please try again later.</div>
        </div>
    </div>

    <div *ngIf="status === 'resubscribed'" class="status-success">
        <div class="icon-container">
            <div><img src="assets/images/success-icon.svg" alt="Success Icon"></div>
        </div>
        <div class="message-container">
            <div class="status-title">You’re All Set!</div>
            <div class="notification-message">We’ll send you updates about your order so you’re always in the loop</div>
        </div>
        <!-- confirmed=true tells the unsubscribe page to skip the confirmation, since
             the user has already clicked through to get here -->
        <div class="resubscribe-prompt"><a [routerLink]="['/unsubscribe']"
                [queryParams]="{ token: token, confirmed: 'true' }" class="resubscribe-link">Unsubscribe</a></div>
    </div>
</section>